import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { ItemRevisionDataset } from 'src/app/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'em-dataset-card-list',
  styleUrls: ['./dataset-card-list.component.less'],
  templateUrl: './dataset-card-list.component.html',
  standalone: false,
})
export class DatasetCardListComponent {
  public readonly trackByRef = trackByRef;

  @Input() public datasets?: ItemRevisionDataset[];
}
